import ExternalAuthorization from './ExternalAuthorization';

export default ExternalAuthorization;
